<template>
  <div class="outer">
    <p v-if="user.state === -1">账号状态查询中, 请稍后</p>
    <p v-if="user.state === 0">
      <img src="../assets/img/error.png" alt="" width="300">
      <el-link type="primary" href="index">点此返回首页</el-link>
    </p>
    <div v-if="user.state === 1">
      <img src="../assets/img/successLight.png" alt="" width="134">
      <h2>账号激活成功</h2>
      用户: {{ user.account }}, 您已成功激活此账号
      <el-link type="primary" href="login">点此登录
      </el-link>
    </div>
    <p v-if="user.state === 2">
      <img src="../assets/img/successLight.png" alt="" width="134">
      用户: {{ user.account }}, 此账号已被激活,
      <el-link type="primary" href="login">点此登录</el-link>
    </p>
  </div>
</template>

<script>
import base from '@/api/common';
import qs from 'qs';

export default {
  name: "activeAccount",
  data() {
    return {
      id: this.$route.query.id,
      token: this.$route.query.token,
      user: {
        account: 'user',
        state: -1,
      }
    }
  },
  mounted() {
    if (!this.id || !this.token) {
      this.route.push('/index');
      return;
    }
    this.$ajax.post(base.basePath + 'ysh/user/email-register/active/' + this.id, qs.stringify({
      token: this.token
    })).then(res => {
      if (res.data.status === 'success') {
        this.user.state = res.data.state;
        this.user.account = res.data.account;
      } else {
        this.$message.error(res.data.message);
        this.user.state = 0;
      }
    }).catch(err => {
      this.$message.error(err);
      this.user.state = 0;
    })
  }
}
</script>

<style lang="scss" scoped>
.outer ::v-deep {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  line-height: 2;
  color: #303139;

  img {
    display: block;
  }

  .el-link {
    display: block;
    margin-top: 10px;

    .el-link--inner {
      height: 41px;
      background: #567BFF;
      border-radius: 2px;
      color: #FFFFFF;
      font-size: 14px;
      display: block;
      text-align: center;
      line-height: 41px;
    }
  }
}

</style>
